import {
    validateSingleSelection,
    validateAccountNumber,
} from '@om/validation';
import {  validateFullName } from '@om/validation/src/validators/string-validator';
import { setSfcBankingDetailsFieldValid } from '../../../actions/sizotsaFuneralCover/bankingDetails';

let prevValidationAction = null;

export const bankingDetailsValidations = (store, next, action) => {
    const validationAction = (() => {
        let error;
        const trimValue = (value) => (value ? value.trim() : value);
        switch (action.value.fieldType) {
            case 'bankName':
                error = validateSingleSelection(action.value.value, 'Bank Name');
                break;

            case 'branchCode':
                error = validateSingleSelection(action.value.value, 'Branch Code');
                break;

            case 'accountHolder':
                error = validateFullName(action.value.value,{min:3, max:66,required:true,subject:'Account holder name'})
                break;

            case 'accountNumber':
                error = validateAccountNumber(action.value.value, {
                    min: 5,
                    max: 13,
                    subject: 'Account number',
                });
                break;

            case 'accountType':
                error = validateSingleSelection(action.value.value, 'Account type');
                break;


            case 'debitOrderDay':
                error = validateSingleSelection(action.value.value, 'Debit order day');
                break;
            case 'paymentFrequency':
                error = validateSingleSelection(action.value.value, 'Payment frequency');
                break;
    
            case 'paymentAuthorization':
                error = validateSingleSelection(action.value.value, 'terms and conditions');
                break;

            default:
                return null;
        }

        return setSfcBankingDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
